export function formatFieldTipo(value) {
  switch (value) {
    case 'E':
      return 'Estoque';
    case 'V':
      return 'Venda';
    case 'C':
      return 'Compras';
    case 'F':
      return 'Funcionários';
    default:
      return '';
  }
}

export function formatFieldStatus(value) {
  switch (value) {
    case 'R':
      return 'Erro Processamento';
    case 'P':
      return 'Processado';
    default:
      return '';
  }
}
